import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

import { BackgroundImage } from '@application/Interfaces/Atoms/BackgroundImage/BackgroundImage'
import { Html } from '@application/Interfaces/Atoms/Html'
import { Revealer } from '@application/Interfaces/Atoms/Revealer'
import { Tilt } from '@application/Interfaces/Atoms/Tilt'
import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import type { ImageHoverDescriptionType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import {
    Description,
    ItemDescription,
    Link,
    ServicesItem,
    ServicesItemWrapper,
    ServiceTitle,
    Title,
    Wrapper,
} from './ImageHoverDescription.styled'
import { getGridSize } from './utils'

export const ImageHoverDescription = (props: ImageHoverDescriptionType): JSX.Element => {
    const { description, serviceSectionItem, mode } = props

    const gridSize = getGridSize(serviceSectionItem.length)

    return (
        <Wrapper $mode={mode}>
            <Container>
                <Revealer
                    multi={{
                        delay: 150,
                    }}
                >
                    <Description>
                        <Html content={description?.data.childMarkdownRemark.html as string} />
                    </Description>
                    <Grid container>
                        {serviceSectionItem.map((item) => {
                            const image = getImage(item.image.localFile) as IGatsbyImageData
                            const Wrapper = item.imageAnimation ? Tilt : React.Fragment
                            return (
                                <Grid
                                    item
                                    xs={12}
                                    md={gridSize}
                                    mdUpSpacingRight={3}
                                    mdUpSpacingLeft={3}
                                    mdUpSpacingBottom={3}
                                    key={item.id}
                                    mdDownSpacingBottom={6}
                                >
                                    <Wrapper>
                                        <ServicesItemWrapper>
                                            <BackgroundImage image={image} title={item.image.alternativeText}>
                                                <>
                                                    <ServiceTitle>{item.title}</ServiceTitle>
                                                    <ServicesItem>
                                                        <Title>{item.title}</Title>
                                                        <ItemDescription>
                                                            <Html
                                                                content={
                                                                    item.description.data.childMarkdownRemark
                                                                        .html as string
                                                                }
                                                            />
                                                            {item.link && item.linkLabel && (
                                                                <Link to={item.link}>
                                                                    {item.linkLabel}
                                                                    <ArrowDirectionIcon />
                                                                </Link>
                                                            )}
                                                        </ItemDescription>
                                                    </ServicesItem>
                                                </>
                                            </BackgroundImage>
                                        </ServicesItemWrapper>
                                    </Wrapper>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Revealer>
            </Container>
        </Wrapper>
    )
}
